<template>
    <el-drawer
        :visible.sync="visible"
        :size="'85%'"
        :destroy-on-close="true"
        :custom-class="'el-drawer-request-block'"
        :with-header="false">
        <div style="background-color: #F6F9FC;" class="p-4">
            <RequestBlock :id="id" />
        </div>
    </el-drawer>
</template>

<script>
import RequestBlock from "./RequestBlock";
export default {
    name: "RequestDrawer",
    components: {RequestBlock},
    data: () => ({
        visible: false,
        id: null,
    }),
    mounted() {
        let self = this;
        this.$bus.$on('request:open-drawer', id => {
            self.visible = false;
            self.id = null;
            self.id = id;
            self.visible = true;
        })
    },
}
</script>

<style scoped>

</style>
